import { render, staticRenderFns } from "./ManageReviewsModal.vue?vue&type=template&id=0084cb89"
import script from "./ManageReviewsModal.vue?vue&type=script&lang=js"
export * from "./ManageReviewsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports